import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatText'
})
export class FormatTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    return value
      .replace(/\n/g, '<br>') // Sostituisce \n con <br>
      .replace(/\t/g, '&emsp;'); // Sostituisce \t con uno spazio tabulato
  }
}
